<template src="./html/RightWidget.html"></template>

<script>
	import ScheduleCreate from './../../schedules/views/Create.vue'
	import CreateTask from './../../tasks/views/Create.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'schedule-create': ScheduleCreate,
			'create-task': CreateTask,
		},
		data () {
			return {
				data: null,
				tasks_pending: null,
				tasks_assigned: null,
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.$emit('reload')
				this.getData()
			},
			getData: function() {
				var status = 'pending'

				if(this.user.hasRole(['admin', 'manager', 'external_manager'])) {
					this.$http.get('admin/projects/tasks/status/pending')
					.then(response => {
						this.tasks_pending = response.body
					})

					this.$http.get('admin/projects/tasks/status/assigned')
					.then(response => {
						this.tasks_assigned = response.body
					})
				}

				this.$http.get('admin/projects/tasks/status/assigned')
				.then(response => {
					this.tasks_assigned = response.body
				})
			},
			openCreateSchedule(task) {
				this.$refs.schedulecreate.item = task
				this.$refs.schedulecreate.open()
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/dashboard/views/RightWidget.vue